module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('loader', {
    attrs: {
      "title": 'Loading services'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix",
    attrs: {
      "id": "preferences-outer"
    }
  }, [_vm._l((_vm.orderedServices), function(item, i) {
    return _c('div', {
      class: _vm.preferenceClasses
    }, [_c('div', {
      staticClass: "a-preference clearfix"
    }, [_c('section', {
      staticClass: "pref-title-action"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('h4', [_vm._v(_vm._s(item.code) + " - " + _vm._s(item.name))]), _vm._v(" "), (_vm.allowDelete) ? _c('span', {
      staticClass: "action-delete pull-right",
      on: {
        "click": function($event) {
          return _vm.del(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times fa-2x"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "clearfix pref-form-els"
    }, [_c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v("From " + _vm._s(_vm.asteriskOrBlank))]), _vm._v(" "), _c('auto-complete', {
      attrs: {
        "dataset": _vm.locationSearchResults,
        "placeHolder": 'Type to search',
        "initVal": item.fromLocation,
        "fnFormatText": _vm.locationFormat,
        "fnSelectValue": _vm.locationFormat
      },
      on: {
        "changing": function (data) { return _vm.locationText = data; },
        "selection-made": function (loc) { return _vm.updateFrom(item, loc); }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v("To " + _vm._s(_vm.asteriskOrBlank))]), _vm._v(" "), _c('auto-complete', {
      attrs: {
        "dataset": _vm.locationSearchResults,
        "placeHolder": 'Type to search',
        "initVal": item.toLocation,
        "fnFormatText": _vm.locationFormat,
        "fnSelectValue": _vm.locationFormat
      },
      on: {
        "changing": function (data) { return _vm.locationText = data; },
        "selection-made": function (loc) { return _vm.updateTo(item, loc); }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v("Provider")]), _vm._v(" "), _c('auto-complete', {
      attrs: {
        "dataset": _vm.partySearchResults,
        "placeHolder": 'Type to search',
        "initVal": item.provider,
        "fnFormatText": _vm.displayParty,
        "fnSelectValue": _vm.displayParty
      },
      on: {
        "changing": function (data) { return _vm.partyText = data; },
        "selection-made": function (p) { return _vm.updateProvider(item, p); }
      }
    })], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-6"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label"
    }, [_vm._v("Amount " + _vm._s(_vm.asteriskOrBlank))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Amount),
        expression: "item.Amount"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": "Enter rate if desired",
        "type": "number"
      },
      domProps: {
        "value": (item.Amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "Amount", $event.target.value)
        }
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": "currency"
      }
    }, [_vm._v("Currency " + _vm._s(_vm.asteriskOrBlank))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.Currency),
        expression: "item.Currency"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "currency"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(item, "Currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.currencies), function(cur, i) {
      return _c('option', {
        domProps: {
          "value": cur,
          "selected": cur.id === item.Currency.id
        }
      }, [_vm._v(_vm._s(cur.name))])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "form-label",
      attrs: {
        "for": "note"
      }
    }, [_vm._v("Note")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.note),
        expression: "item.note"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (item.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "note", $event.target.value)
        }
      }
    })])])])])])])])
  }), _vm._v(" "), (_vm.allowAdd) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "blank-outer"
  }, [_c('div', {
    staticClass: "blank-pref",
    on: {
      "click": function($event) {
        _vm.adding = true
      }
    }
  }, [_c('div', [(!_vm.adding) ? _c('i', {
    staticClass: "fa fa-plus oversized"
  }) : _vm._e(), _vm._v(" "), (_vm.adding) ? _c('div', {
    staticClass: "restricted"
  }, [_c('h2', [_vm._v("Select a Service")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.serviceSelector),
      expression: "serviceSelector"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.serviceSelector = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.allServices), function(s, i) {
    return _c('option', {
      domProps: {
        "value": s
      }
    }, [_vm._v(_vm._s(s.code) + " - " + _vm._s(s.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.addService(_vm.serviceSelector)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n                    Cancel\n                  ")])])])]) : _vm._e()])])])]) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-685c3dd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/Preferences.vue
// module id = 2207
// module chunks = 1